"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserBasicProfileForm = UserBasicProfileForm;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _api = require("@focaltec-suite/api");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function UserBasicProfileForm() {
  var _a;
  var validators = (0, _react.useMemo)(function () {
    return [new _commons.PhoneValidator()];
  }, []);
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var sessionUser = (_a = context.session) === null || _a === void 0 ? void 0 : _a.user;
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    register = _useValidatedForm.register,
    bind = _useValidatedForm.bind;
  var user = (0, _react.useMemo)(function () {
    return sessionUser;
  }, [sessionUser]);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    format = _useState2[0],
    setFormat = _useState2[1];
  var setUser = (0, _react.useCallback)(function (user) {
    if (!context.session) return;
    var curr = context.session.user;
    context.session.user = Object.assign(Object.assign({}, curr), {
      first_name: user.first_name,
      last_name: user.last_name,
      phone: user.phone
    });
  }, [context.session]);
  var hasChangedPhone = function hasChangedPhone(name, value) {
    var newFormat = (0, _commons.phoneFormat)(value ? value : '');
    if (format !== newFormat) {
      setFormat(newFormat);
    }
  };
  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    if (!isValid()) {
      return;
    }
    var request = bind();
    feedbackContext.showBackdrop();
    (0, _api.updateBasicProfile)(request, {
      access: access
    }).then(function (user) {
      feedbackContext.showSuccess((0, _core.translate)('users.profile.updated_basic'));
      setUser(user);
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.Surface, {
    title: (0, _core.translate)('users.profile.basic'),
    icon: /*#__PURE__*/_react["default"].createElement(_commons.ProfileIcon, null)
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement("form", {
    autoComplete: "off",
    noValidate: true,
    onSubmit: onSubmit
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    type: "text",
    name: "first_name",
    label: (0, _core.translate)('users.first_name'),
    initialValue: user.first_name,
    register: register,
    required: true
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    type: "text",
    name: "last_name",
    label: (0, _core.translate)('users.last_name'),
    initialValue: user.last_name,
    register: register,
    required: true
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyMaskedInput, {
    name: "phone",
    label: (0, _core.translate)('users.phone'),
    initialValue: user.phone,
    register: register,
    notifier: hasChangedPhone,
    validators: validators,
    mask: " ",
    format: format
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    my: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    fullWidth: true,
    size: "large"
  }, (0, _core.translate)('buttons.update')))))))));
}